import * as yup from "yup";
import { AbstractAuthorRoles } from "../../models/abstract";
import { FormValidationModel } from "../../models/validation";
import { DefaultPhoneNumber, PhoneNumberData, PhoneNumberSchema, PhoneNumberSchemaRequired } from "../generic";

export interface AbstractAuthorData {
    deleted: boolean;
    displayProfilePicture: boolean;
    email: string;
    firstName?: string;
    id: number;
    index: number;
    isMember: boolean;
    isNew?: boolean;
    legacyMemberId?: number;
    lastName?: string;
    phone: PhoneNumberData | null;
    profilePicture?: string;
    roleId: number;
    sort: number;
    title?: string;
    userId: number;
}

export class AbstractAuthor implements FormValidationModel<AbstractAuthorData> {
    public data: AbstractAuthorData;
    public rules: yup.Schema<AbstractAuthorData>;

    public constructor() {
        this.data = {
            ...DefaultAbstractAuthor,
        };
        this.rules = yup.object<AbstractAuthorData>().shape({
            deleted: yup.bool(),
            displayProfilePicture: yup.boolean(),
            email: yup.string().email().label("Email address").required(),
            firstName: yup.string().label("First name").max(50),
            id: yup.number().label("Co author ID").min(0, "Invalid $label"),
            isMember: yup.bool().label("Is member"),
            index: yup.number(),
            lastName: yup.string().label("Last name").max(50),
            phone: PhoneNumberSchema.label("Mobile phone number").when(["roleId"], (roleId: number) => {
                return AbstractAuthorRoles.isPrimary(roleId)
                    ? PhoneNumberSchemaRequired.label("Mobile phone number")
                    : PhoneNumberSchema.label("Mobile phone number");
            }),
            profilePicture: yup.string().nullable(true).label("Profile picture"),
            roleId: yup.number().nullable(true).oneOf(AbstractAuthorRoles.IDs, "Please select a valid author role").required().label("Role"),
            sort: yup.number(),
            title: yup.string().nullable(true).label("Title").max(100),
            userId: yup.number().label("Co author user ID").min(0, "Invalid $label"),
        });
    }
}

export const AbstractAuthorSchema = new AbstractAuthor().rules;

export const DefaultAbstractAuthor: AbstractAuthorData = {
    deleted: false,
    displayProfilePicture: false,
    id: 0,
    isMember: false,
    index: 0,
    email: "",
    phone: { ...DefaultPhoneNumber },
    roleId: AbstractAuthorRoles.Primary.id,
    sort: 0,
    userId: 0,
};



// WEBPACK FOOTER //
// ./src/forms/adminAbstracts/AbstractAuthor.ts